import { Functions, httpsCallable } from 'firebase/functions';
import {
  BULK_ADD_TEAM_MEMBERS_CLIENT_TIMEOUT_MS,
  SyncTeamGroupUsersFnReq,
  SyncTeamGroupUsersFnRes,
} from '@uploadcam/common';
import { GetAuthDtoInteractor } from '../../../auth/domain/interactors/get-auth-dto.interactor';

export class SyncTeamGroupUsersInteractor {
  private readonly syncTeamGroupUsersFn = httpsCallable<
    SyncTeamGroupUsersFnReq,
    SyncTeamGroupUsersFnRes
  >(this.functions, 'syncTeamGroupUsers', { timeout: BULK_ADD_TEAM_MEMBERS_CLIENT_TIMEOUT_MS });

  constructor(
    private readonly functions: Functions,
    private readonly getAuthDto: GetAuthDtoInteractor,
  ) {}

  public async execute(
    data: Omit<SyncTeamGroupUsersFnReq, 'auth'>,
  ): Promise<SyncTeamGroupUsersFnRes> {
    const res = await this.syncTeamGroupUsersFn({
      auth: await this.getAuthDto.execute(),
      ...data,
    });

    return {
      syncResult: res.data.syncResult,
    };
  }
}
